<template>
  <div id="cesiumContainer">
  </div>
</template>
<script type="text/javascript">
    Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJjY2M1ZTdjNC1hOWUxLTQ2ZWEtYmM5Ni1lYjEzNGJhNzc2NmYiLCJpZCI6MTM0MiwiaWF0IjoxNTI4MDYzODgzfQ.qO6HZF_HAdE1FFcI76GQ3nX6RtDBULrCj80qWmy_E0g';


import Cesium from 'cesium/Cesium'
import widgets from 'cesium/Widgets/widgets.css'
import axios from 'axios'
import store from '../store'

export default {
  name: 'cesiumViewer',

  data() {
    return {
      map: null,
      datos: [],
      marcadores: [],
      opciones: [
        { num: 0, nom: 'Institucion' },//informacion general edificio y area
        { num: 1, nom: 'Administrativas' },//indicadores 
        { num: 2, nom: 'Facultades' },//indicadores 
        { num: 3, nom: 'Carreras' },//indicadores 
        { num: 4, nom: 'Extensiones' },//indicadores 
        { num: 5, nom: 'Infraestructura' },//edficios con area de influencia
      ],
      viewer: null
    }
  },
  methods: {
    updateOptionActive (opc) {
      store.commit('UPDATEOPTIONACTIVE',opc)
    },
    resetOptionActive() {
      store.commit('RESETOPTIONACTIVE')
    },
    updateTitle(title){
      store.commit('UPDATETITLE',title)
    },


    /*********************************************/
    consultaApi(opc) {
      this.datos.length = 0;
      axios.get('http://cimogsys.espoch.edu.ec:3000/api/'+ opc).then((response) => {
      //axios.get('http://localhost:3000/api/'+ opc).then((response) => {
        this.datos = response.data.data;
        console.log(this.datos)

        this.cargarMarcadores(opc);
      });
    },

    cargarMarcadores(opc) {
      this.marcadores.length=0;

      var marcador = new Object();
          marcador.edificio=new Object();
          marcador.areasExtra=[];

      if (opc!=6) {

        var areaExtra1 = new Object();

        areaExtra1.idArea=this.datos[0].id_area;
        areaExtra1.nombreArea=this.datos[0].nombre_area;
        areaExtra1.aliasArea=this.datos[0].alias_area;
        areaExtra1.padreArea=this.datos[0].padre_area;
        areaExtra1.tipoArea=this.datos[0].tipo_area;
        areaExtra1.contactoArea=this.datos[0].contacto_area;
        areaExtra1.enlaceArea=this.datos[0].enlace_area;
        areaExtra1.representanteArea=this.datos[0].representante_area;
        areaExtra1.sgiaArea=this.datos[0].sgia_area;
        areaExtra1.sgpArea=this.datos[0].sgp_area;
        areaExtra1.siebArea=this.datos[0].sieb_area;

        marcador.edificio=this.datos[0];
        marcador.areasExtra[0]=areaExtra1;

        this.marcadores[0]=marcador;

        var contadorMarcadores=0;

          for (var i = 1; i <this.datos.length; i++) {
            
            if(this.marcadores[contadorMarcadores].edificio.id_edificio==this.datos[i].id_edificio){
              var areaExtra3 = new Object();
              areaExtra3.idArea=this.datos[i].id_area;
              areaExtra3.nombreArea=this.datos[i].nombre_area;
              areaExtra3.aliasArea=this.datos[i].alias_area;
              areaExtra3.padreArea=this.datos[i].padre_area;
              areaExtra3.tipoArea=this.datos[i].tipo_area;
              areaExtra3.contactoArea=this.datos[i].contacto_area;
              areaExtra3.enlaceArea=this.datos[i].enlace_area;
              areaExtra3.representanteArea=this.datos[i].representante_area;
              areaExtra3.sgiaArea=this.datos[i].sgia_area;
              areaExtra3.sgpArea=this.datos[i].sgp_area;
              areaExtra3.siebArea=this.datos[i].sieb_area;


              this.marcadores[contadorMarcadores].areasExtra.push(areaExtra3);
            }
            else{
              var marcador2 = new Object();
              marcador2.edificio=new Object();
              marcador2.areasExtra=[];
              var areaExtra2 = new Object();

              areaExtra2.idArea=this.datos[i].id_area;
              areaExtra2.nombreArea=this.datos[i].nombre_area;
              areaExtra2.aliasArea=this.datos[i].alias_area;
              areaExtra2.padreArea=this.datos[i].padre_area;
              areaExtra2.tipoArea=this.datos[i].tipo_area;
              areaExtra2.contactoArea=this.datos[i].contacto_area;
              areaExtra2.enlaceArea=this.datos[i].enlace_area;
              areaExtra2.representanteArea=this.datos[i].representante_area;
              areaExtra2.sgpArea=this.datos[i].sgp_area;
              areaExtra2.siebArea=this.datos[i].sieb_area;
              areaExtra2.sgiaArea=this.datos[i].sgia_area;


              marcador2.edificio=this.datos[i];
              marcador2.areasExtra[0]=areaExtra2;

              contadorMarcadores++;
              this.marcadores[contadorMarcadores]=marcador2;
            }
          }
      }

      else
      {

        var marcador4 = new Object();
            marcador4.edificio=new Object()
            marcador4.areasExtra=[];

        for (var i=0 ; i < this.datos.length; i++) {
          var marcador4 = new Object();
          marcador4.edificio=this.datos[i];
          this.marcadores.push(marcador4);
        }
      }

      this.ubicarMarcadores(opc);
    },
    calcularColor(porcentaje){
      if ( porcentaje>=0 && porcentaje<=33){
        return ("red");
      }
      else if (porcentaje>=34 && porcentaje<=66){
        return ("orange");
      }
      else {
        return ("green");
      }
    },

    calcularColorEstela(numero){
      
      switch(numero) {
        case 0:
            return ("#aaccbb");
          break;
        case 1:
            return ("#bbcccc");
          break;
        case 2:
            return ("#6699bb");
          break;
        case 3:
            return ("#337788");
          break;
        case 4:
            return ("#115566");
          break;
        case 5:
            return ("#113344");
          break;
        default:
            return ("#113344");
      }
    
    },

    crearDescripcion(indiceMarcador, opcionActiva){
      var descripcion=''
      var imagenArea="espoch"

      if (opcionActiva==1) {
        for (var j = 0; j < this.marcadores[indiceMarcador].areasExtra.length; j++) {
          descripcion+= '<hr>'+ 
             '<div  class="tabla_titulo">'+this.marcadores[indiceMarcador].areasExtra[j].nombreArea+

             '</div> <div class="tabla_cuerpo">'+
            //'<div class="tabla_logo"> <img class="logo" src="http://127.0.0.1:8887/geoportal_files/LOGOS/'
             '<div class="tabla_logo"> <img class="logo" src="http://cimogsys.espoch.edu.ec/geoportal_files/LOGOS/'
            +this.marcadores[indiceMarcador].areasExtra[j].aliasArea+'.png"></div>'+
            

            '<div class="tabla_datos datos">'+
              '<div class="tabla_row row">'+ 
                  '<div class="tabla_etiqueta">Director: </div>'+ 
                  '<div  class="tabla_info">'+this.marcadores[indiceMarcador].areasExtra[j].representanteArea+'</div>'+
              '</div>'+
               '<div class="tabla_row row">'+ 
                  '<div class="tabla_etiqueta">Contacto: </div>'+ 
                  '<div  class="tabla_info">'+this.marcadores[indiceMarcador].areasExtra[j].contactoArea+'</div>'+
              '</div>'+
              '<div class="tabla_row row">'+ 
                  '<div class="tabla_etiqueta">Web: </div>'+ 
                  '<div class="tabla_info"><a>'+this.marcadores[indiceMarcador].areasExtra[j].enlaceArea+' </a></div>'+
              '</div>'+
            '</div>'+
          '</div>'
        }
      }

      else if (opcionActiva==6) {
         descripcion+=
            '<div class="tabla_foto">' + 
                //'<img class="foto" src="http://127.0.0.1:8887/geoportal_files/FOTOS/espoch.jpg">'+
                 '<img class="foto" src="http://cimogsys.espoch.edu.ec/geoportal_files/FOTOS/espoch.jpg">'+
          '</div>';
      }
      
      
      else{

        for (var j = 0; j < this.marcadores[indiceMarcador].areasExtra.length; j++) {
          descripcion+=
             '<div  class="tabla_titulo">'+this.marcadores[indiceMarcador].areasExtra[j].nombreArea+

             '</div> <div class="tabla_cuerpo">'+
            '<div class="tabla_logo"> <img class="logo" src="http://cimogsys.espoch.edu.ec/geoportal_files/LOGOS/'+this.marcadores[indiceMarcador].areasExtra[j].aliasArea+'.png"></div>'+
            '<div class="tabla_datos">'+
         
               '<div class="tabla_row">'+ 
                  '<div class="tabla_etiqueta">Indicador de Procesos:</div>'+ 
                  '<div class="tabla_barra"><div  class="tabla_info" style="background-color:'+this.calcularColor(this.marcadores[indiceMarcador].areasExtra[j].sgpArea)+'; width:'+this.marcadores[indiceMarcador].areasExtra[j].sgpArea+'%;" >'+this.marcadores[indiceMarcador].areasExtra[j].sgpArea+'%</div></div>'+
                  '<div class="tabla_acronimo">SGIP</div>'+ 
              '</div>'+
               '<hr class="popup">'+
              '<div class="tabla_row">'+ 
                  '<div class="tabla_etiqueta">Indicador de Planificación:</div>'+ 
                  '<div class="tabla_barra"><div  class="tabla_info" style="background-color:'+this.calcularColor(this.marcadores[indiceMarcador].areasExtra[j].siebArea)+'; width:'+this.marcadores[indiceMarcador].areasExtra[j].siebArea+'%;" >'+this.marcadores[indiceMarcador].areasExtra[j].siebArea+'%</div></div>'+
                  '<div class="tabla_acronimo">SIEB</div>'+
                    
              '</div>'+
               '<hr class="popup">'+
               '<div class="tabla_row">'+ 
                  '<div class="tabla_etiqueta" >Indicador de Acreditación:</div>'+ 

                   '<div class="tabla_barra"><div  class="tabla_info" style="background-color:'+this.calcularColor(this.marcadores[indiceMarcador].areasExtra[j].sgiaArea)+'; width:'+this.marcadores[indiceMarcador].areasExtra[j].sgiaArea+'%;" >'+this.marcadores[indiceMarcador].areasExtra[j].sgiaArea+'%</div> </div>'+
                  '<div class="tabla_acronimo">SGIA</div>'+ 
                  

              '</div>'+
            '</div>'+
          '</div>'
        }
      }
      
      return (descripcion);
    },

    ubicarMarcadores(opc) {
      this.viewer.entities.removeAll();
      var textoDescripcion="";
        
      for (var i = 0; i < this.marcadores.length; i++) {

       var posicion = Cesium.Cartesian3.fromDegrees(this.marcadores[i].edificio.geometry.coordinates[0], this.marcadores[i].edificio.geometry.coordinates[1]);
        var heading = Cesium.Math.toRadians(this.marcadores[i].edificio.orientacion_edificio); 
        var hpr = new Cesium.HeadingPitchRoll(heading, 0, 0);
        var orientacion = Cesium.Transforms.headingPitchRollQuaternion(posicion, hpr);
      
        var descripcion= this.crearDescripcion(i, this.getOptionActive)


        var color =  null;
        var colorAlternativo =  null;
        var translucentColor =  null;
        var translucentColorAlternativo =  null;

        if(opc!=6){
            color =  Cesium.Color.CADETBLUE;
            colorAlternativo = Cesium.Color.fromCssColorString('grey');
            translucentColor = color.withAlpha(0.7);
            translucentColorAlternativo = colorAlternativo.withAlpha(0.7);
        }

        else{
            color =  Cesium.Color.fromCssColorString(this.calcularColorEstela(this.marcadores[i].edificio.condicion_edificio));
            colorAlternativo = Cesium.Color.fromCssColorString('grey');
            translucentColor = color.withAlpha(0.7);
            translucentColorAlternativo = colorAlternativo.withAlpha(0.7);
        }


        //var colorEstela= parseInt(this.marcadores[i].edificio.condicion_edificio);


        var material= translucentColor

        if (this.marcadores[i].edificio.estado_edificio==0) {
            material= translucentColorAlternativo;
        }

        var escala= parseFloat(this.marcadores[i].edificio.escala_edificio)

        var entity = this.viewer.entities.add({
          name:this.marcadores[i].edificio.nombre_edificio,
          position: posicion,
          orientation: orientacion,
          model: {
            uri: 'http://cimogsys.espoch.edu.ec/geoportal_files/MODELOS/' + this.marcadores[i].edificio.descripcion_edificio + '.glb',
            //uri: 'http://127.0.0.1:8887/MODELOS/' + this.marcadores[i].edificio.descripcion_edificio + '.glb',
            scale : 5*escala,
          },
          ellipse : {
            semiMinorAxis : 30,
            semiMajorAxis : 30,
            height: 0.0,
            material : material,
            //show: false,
          },
          label : {
                text : name,
                verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
                pixelOffset : new Cesium.Cartesian2(0, -150),
                show: true, 
                scale: 0.5,
            },
          description:descripcion
        });
      }

        var viewer = this.viewer

        var nameOverlay = document.createElement('div');
        viewer.container.appendChild(nameOverlay);
        nameOverlay.className = 'backdrop';
        nameOverlay.style.display = 'none';
        nameOverlay.style.position = 'absolute';
        nameOverlay.style.bottom = '0';
        nameOverlay.style.left = '0';
        nameOverlay.style['pointer-events'] = 'none';
        nameOverlay.style.padding = '4px';
        nameOverlay.style.backgroundColor = 'black';
        var selected = {
            feature: undefined,
            originalColor: new Cesium.Color()
        };

        var selectedEntity = new Cesium.Entity();
        var clickHandler = viewer.screenSpaceEventHandler.getInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        var highlighted = {
            feature : undefined,
            originalColor : new Cesium.Color()
        };

        // Color a feature yellow on hover.
        viewer.screenSpaceEventHandler.setInputAction(function onMouseMove(movement) {
            // If a feature was previously highlighted, undo the highlight
            if (Cesium.defined(highlighted.feature)) {
                //highlighted.feature.id.ellipse.material = highlighted.originalColor;
                highlighted.feature.color = highlighted.originalColor;
                highlighted.feature = undefined;
            }
            // Pick a new feature
            var pickedFeature = viewer.scene.pick(movement.endPosition);
            if (!Cesium.defined(pickedFeature)) {
                nameOverlay.style.display = 'none';
                return;
            }
            // A feature was picked, so show it's overlay content
            nameOverlay.style.display = 'block';
            nameOverlay.style.bottom = viewer.canvas.clientHeight - movement.endPosition.y + 'px';
            nameOverlay.style.left = movement.endPosition.x + 'px';
            var name = pickedFeature.id.name;
           // var name = pickedFeature.name;
            //console.log(pickedFeature.id.name)
        
            if (!Cesium.defined(name)) {
                name = pickedFeature.getProperty('id');
            }
            nameOverlay.textContent = name;
            // Highlight the feature if it's not already selected.
            if (pickedFeature !== selected.feature) {
                highlighted.feature = pickedFeature;
                Cesium.Color.clone(pickedFeature.color, highlighted.originalColor);
                pickedFeature.color = Cesium.Color.YELLOW;
            }
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      this.viewer.flyTo(entity);
    }
  },
  computed: {
    getMenuState () {
      return store.state.menuState
    },
    getOptionActive () {
      return store.state.optionActive
    },  
    getMapTitle() {
      return store.state.mapTitle
    },      
  },
  watch: {
    '$route' (to, from) {
        this.updateOptionActive(this.$route.params.opcion);
        this.updateTitle(this.opciones[parseInt(this.$route.params.opcion)-1].nom);

      this.consultaApi(this.$route.params.opcion);
    }
  },
  mounted() {
    this.viewer = new Cesium.Viewer('cesiumContainer',
      {
        /*imageryProvider: new Cesium.ArcGisMapServerImageryProvider({
            url: '//services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer'
        }),*/
        scene3DOnly: true,
        selectionIndicator: false,
        baseLayerPicker: false,
        bottomContainer:false,
        homeButton:false,
        helpButton:false
      });
    this.consultaApi(this.$route.params.opcion);
    
    this.viewer.infoBox.frame.removeAttribute('sandbox');

    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(-78.677308, -1.661106, 500),
      orientation: {
        heading: Cesium.Math.toRadians(-10.0),
        pitch: Cesium.Math.toRadians(-40.0),
        roll: 0.0}});
  }
}

</script>



<style lang="scss" src="../sass/mapa.scss" scoped></style>
<style lang="css" src="../sass/infoBox.css" ></style>






// WEBPACK FOOTER //
// src/components/cesiumViewer.vue